import { positionReducers } from '../reducers'

export const positionRootReducers = {
  position: positionReducers,
}
